import {ChangeDetectorRef, Component, forwardRef, Input, Optional} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractControl} from "../framework/abstract-control";
import {FUIFormContext} from "../../form-context/form-context";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUISearchControlComponent),
            multi: true
        }
    ],
    selector: "fui-search-control",
    templateUrl: "./search-control.component.html",
    standalone: false
})
export class FUISearchControlComponent extends FUIAbstractControl {
    /**
     * Indicates if the search control can be removed when in pill mode
     */
    @Input() public removable: boolean = true;

    constructor(changeDetectorRef: ChangeDetectorRef,
                @Optional() public context: FUIFormContext) {
        super(changeDetectorRef);
    }
}
